// extracted by mini-css-extract-plugin
export default {"root":"tag-filter_root__EMpiK"};